import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Link } from "react-router-dom";
import Logo from "../assets/Doorstep_logo.png";

const Header = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [userType, setUserType] = useState("");
const [EName, setEName] = useState("");
const [EQualification, setEQualification] = useState("");
const [EPhone, setEPhone] = useState("");
const [EEmail, setEEmail] = useState("");
const [Emsg, setEmsg] = useState("");
const [TQualification, setTQualification] = useState("");
const [TSubject, setTSubject] = useState("");
const [TExperience, setTExperience] = useState("");
const Enquiryf = async () => {
  try {
    const data = {
      userType,
      EName,
      EPhone,
      EEmail,
      Emsg,
    };

    // If the user is a student, include their qualification
    if (userType === "student") {
      data.EQualification = EQualification;
    }

    // If the user is a teacher, include their details
    if (userType === "teacher") {

      data.TQualification = TQualification;
      data.TSubject = TSubject;
      data.TExperience = TExperience;
      // data.Tmsg = Tmsg;
    }

    const response = await axios.post("/api/user/enquiry", data, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.status === 201) {
      alert("Enquiry submitted successfully!");
      handleClose(); // Ensure handleClose is defined in your component
      window.location.reload();
    }
  } catch (error) {
    console.error(error);
    alert(error.response?.data?.message || "An error occurred while submitting the enquiry.");
  }
};
  const [AddContactuse, setAddContactuse] = useState([]);
  const getAddContactuss = async () => {
    try {
      // alert("fdffdd")
      let res = await axios.get(
        "/api/user/getallContactus"
      );
      if (res.status == 200) {
        setAddContactuse(res.data.getContactusnow);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAddContactuss();
  }, []);
  console.log(AddContactuse);
  return (
    <>
      {/* Top Bar - Logo, Phone, Email, Enquire Now */}
      <div style={{ backgroundColor: "#f0ece4", padding: "10px 80px", borderTop: "4px solid #8B4513" }}>
        <Container fluid className="d-flex align-items-center justify-content-between flex-wrap" style={{ paddingLeft: "60px", paddingRight: "60px" }}>
          <a href="/">
            <img
              src={Logo}
              alt="DoorStep Logo"
              style={{ width: "110px", height: "80px" }}
            />
          </a>

          <div className="d-flex align-items-center flex-wrap" style={{ gap: "25px" }}>
            {AddContactuse?.map((item) => {
              return (
                <React.Fragment key={item?._id}>
                  <span style={{ color: "#333", fontSize: "15px", fontWeight: "500" }}>
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: "#00a695" }}
                    />{" "}
                    {item?.Phone}
                  </span>
                  <span style={{ color: "#333", fontSize: "15px", fontWeight: "500" }}>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: "#00a695" }}
                    />{" "}
                    {item?.Email}
                  </span>
                </React.Fragment>
              );
            })}
            <button className="btn10" onClick={handleShow} style={{ backgroundColor: "#00a695", color: "#fff", borderRadius: "20px", padding: "8px 22px", border: "2px solid #00a695", fontWeight: "600", fontSize: "14px" }}>
              ENQUIRE NOW
            </button>
          </div>
        </Container>
      </div>

      {/* Bottom Nav Bar - Navigation Links */}
      <Navbar
        style={{ backgroundColor: "#00a695", padding: "14px 0px" }}
        expand="lg"
        className="navbar-bottom"
      >
        <Container style={{ maxWidth: "90%" }}>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center" style={{ gap: "10px" }}>
              <div className="dropdown">
                <a href="/" className="dropbtn">
                  HOME
                </a>
                <div className="dropdown-content">
                  <a href="https://forms.eduqfix.com/doorstepolform/add" target="_blank" rel="noopener noreferrer">FIND TUTOR</a>
                  <a href="https://forms.eduqfix.com/tutorform/add" target="_blank" rel="noopener noreferrer">FIND STUDENT</a>
                </div>
              </div>

              <div className="dropdown">
                <a href="/aboutus" className="dropbtn">
                  ABOUT US
                </a>
                <div className="dropdown-content">
                  <a href="/aboutus#faculty">FACULTY</a>
                  <a href="/aboutus#gallery">GALLERY</a>
                </div>
              </div>

              <div className="dropdown">
                <a href="/examdesk" className="dropbtn">
                  EXAM DESK
                </a>
                <div className="dropdown-content">
                  <a href="/examdesk#mcq">MCQ TEST</a>
                  <a href="/examdesk#subjective">SUBJECTIVE TEST</a>
                  <Link to="/quebank">QUESTION BANK</Link>
                </div>
              </div>

              <div className="dropdown">
                <a href="/tution" className="dropbtn">
                  TUITION
                </a>
                <div className="dropdown-content">
                  <a href="/tution#online">ONLINE</a>
                  <a href="https://forms.eduqfix.com/doorstepolform/add" target="_blank">HOME TUITION</a>
                  <a href="https://forms.eduqfix.com/doorstepolform/add" target="_blank">INSTITUTE</a>
                </div>
              </div>

              <div className="dropdown">
                <a href="/trainingandplacement" className="dropbtn">
                  TEACHER TRAINING & PLACEMENT
                </a>
                <div className="dropdown-content">
                  <a href="/skilldevelopment">SKILL DEVELOPMENT</a>
                  <a href="/becomeatutor">BECOME A TUTOR</a>
                </div>
              </div>

              <div className="dropdown">
                <a href="/contact" className="dropbtn">
                  CONTACT US
                </a>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#00a695" }}>Enquire Now</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Selection Dropdown */}
        <FloatingLabel controlId="floatingSelect" label="Who are you?">
          <Form.Select
            className="rtyui_0"
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
          >
            <option value="">Select</option>
            <option value="student">Student</option>
            <option value="teacher">Teacher</option>
          </Form.Select>
        </FloatingLabel>

        {/* Student Fields */}
        {userType === "student" && (
          <>
            <FloatingLabel controlId="floatingInput" label="Enter Your Name">
              <Form.Control
                type="text"
                className="rtyui_0"
                value={EName}
                onChange={(e) => setEName(e.target.value)}
              />
            </FloatingLabel>

           
            <FloatingLabel controlId="floatingInput" label="Mobile No">
              <Form.Control
                type="number"
                className="rtyui_0"
                value={EPhone}
                onChange={(e) => setEPhone(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId="floatingTextarea2" label="Message">
              <Form.Control
                as="textarea"
                style={{ height: "100px" }}
                className="rtyui_0"
                value={Emsg}
                onChange={(e) => setEmsg(e.target.value)}
              />
            </FloatingLabel>
          </>
        )}

        {/* Teacher Fields */}
        {userType === "teacher" && (
          <>
            <FloatingLabel controlId="floatingInput" label="Enter Your Name">
              <Form.Control
                type="text"
                className="rtyui_0"
                value={EName}
                onChange={(e) => setEName(e.target.value)}
              />
            </FloatingLabel>
            <FloatingLabel controlId="floatingInput" label="Mobile No">
              <Form.Control
                type="number"
                className="rtyui_0"
                value={EPhone}
                onChange={(e) => setEPhone(e.target.value)}
              />
            </FloatingLabel>
            <FloatingLabel controlId="floatingInput" label="Email">
              <Form.Control
                type="email"
                className="rtyui_0"
                value={EEmail}
                onChange={(e) => setEEmail(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId="floatingInput" label="Enter Your Qualification">
              <Form.Control
                type="text"
                className="rtyui_0"
                value={TQualification}
                onChange={(e) => setTQualification(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId="floatingInput" label="Subject Expertise">
              <Form.Control
                type="text"
                className="rtyui_0"
                value={TSubject}
                onChange={(e) => setTSubject(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId="floatingInput" label="Years of Experience">
              <Form.Control
                type="number"
                className="rtyui_0"
                value={TExperience}
                onChange={(e) => setTExperience(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId="floatingTextarea2" label="Message">
              <Form.Control
                as="textarea"
                style={{ height: "100px" }}
                className="rtyui_0"
                value={Emsg}
                onChange={(e) => setEmsg(e.target.value)}
              />
            </FloatingLabel>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          onClick={Enquiryf}
          style={{ backgroundColor: "#00a695", border: "none" }}
        >
          Send Request
        </Button>
      </Modal.Footer>
    </Modal>

    </>
  );
};

export default Header;
